import { render, staticRenderFns } from "./CoachBlockGenerator.vue?vue&type=template&id=424059e2&"
import script from "./CoachBlockGenerator.vue?vue&type=script&lang=js&"
export * from "./CoachBlockGenerator.vue?vue&type=script&lang=js&"
import style0 from "./CoachBlockGenerator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports